module.exports = __webpack_public_path__ + "img/dr_1.b439ba89.png";